import React, { FC, useCallback, useEffect, useState, useRef } from 'react';
import { debounce } from 'lodash';
import cn from 'classnames';
import { FilterCollapseKeys } from '../CarFilterCollapse';

import style from './style.module.scss';

type TProps = {
  isShowPanel: boolean;
  filterComponent: React.ReactNode;
  onChangeShow: (v: boolean) => void;
  onChangeActiveKey: (keys: FilterCollapseKeys | FilterCollapseKeys[]) => void;
};

const CarFilterFixed: FC<TProps> = ({ filterComponent, onChangeShow, onChangeActiveKey, isShowPanel }: TProps) => {
  const elCarInfoRef = useRef<HTMLElement | null>(null);
  const elHeaderSite = document.querySelector('header.header') as HTMLElement;
  const [visibility, setVisibility] = useState(false);

  const toggleVisibilityHeader = (display: string) => {
    elHeaderSite.style.display = display;
  };

  const scrollHandler = useCallback(() => {
    const clientRect = elCarInfoRef.current?.getBoundingClientRect();

    if (!clientRect?.bottom) return;

    if (clientRect.bottom <= 0) {
      setVisibility(true);

      toggleVisibilityHeader('none');
    } else {
      debounce(onChangeActiveKey, 250)([]);
      debounce(onChangeShow, 250)(false);
      setVisibility(false);
      toggleVisibilityHeader('block');
    }
  }, []);

  useEffect(() => {
    elCarInfoRef.current = document.querySelector('.aui-CarsBar');
    window.addEventListener('scroll', scrollHandler);

    return () => {
      toggleVisibilityHeader('block');
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);
  
  return (
    <div
      className={cn(
        style.wrap,
        {
          [style.active]: visibility,
          [style.full]: isShowPanel,
        },
        'pt-2 pt-md-0'
      )}
     >
       {filterComponent}
    </div>
  );
};

export default React.memo(CarFilterFixed);
